<template>
<div>
    <div style="position: relative">
        <v-progress-linear v-if="loading" indeterminate color="green" height="4" style="position: absolute"/>
        <div v-else-if="error" class="pa-3 text-center red--text">
            {{error}}
        </div>
    </div>

    <template v-if="latency_chart || errors_chart">
        <div class="text-md-h6 mb-4">
            Service Level Indicators
        </div>


        <div class="grey--text mt-3">
            <v-icon size="20" style="vertical-align: baseline">mdi-lightbulb-on-outline</v-icon>
            Select a chart area to identify the root cause of an anomaly.
        </div>

        <v-row>
            <v-col cols="12" md="6">
                <Chart v-if="latency_chart" :chart="latency_chart" class="my-5 chart" :loading="loading" @select="explainAnomaly" :selection="selection" />
            </v-col>
            <v-col cols="12" md="6">
                <Chart v-if="errors_chart" :chart="errors_chart" class="my-5 chart" :loading="loading" @select="explainAnomaly" :selection="selection" />
            </v-col>
        </v-row>
    </template>

    <template v-else-if="!loading">
        <div class="grey--text text-center">
            No Service Level Indicators (SLIs) found for this application
        </div>
    </template>

    <div v-if="causes && causes.length > 0">
        <div class="text-md-h6 mb-4">
            Possible causes
        </div>

        <v-simple-table>
            <thead>
                <tr>
                    <th>Summary</th>
                    <th>Affected services</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="c in causes">
                    <td>
                        <div>
                            <v-icon color="error" small class="mr-1">mdi-alert-circle</v-icon>
                            <span v-html="c.summary" />
                        </div>
                        <div v-for="d in c.details" class="ml-5"><span v-html="d" class="caption grey--text"/></div>
                    </td>
                    <td>
                        <span v-for="(s, i) in c.affected_services">
                            <i>{{s}}</i>
                            <span v-if="i+1 < c.affected_services.length">, </span>
                        </span>
                    </td>
                </tr>
            </tbody>
        </v-simple-table>
    </div>

    <div v-if="tree.length">
        <div class="text-md-h6 my-4">
            Detailed RCA report
        </div>

        <div>
            <RcaItem v-for="h in tree" :key="h.id" :hyp="h" :split="70" />
        </div>
    </div>
</div>
</template>

<script>
import {palette} from "@coroot/coroot/src/utils/colors";
import RcaItem from "@/components/RcaItem.vue";
import Chart from "@coroot/coroot/src/components/Chart.vue";

export default {
    props: {
        appId: String,
    },

    components: {Chart, RcaItem},

    data() {
        return {
            loading: false,
            error: '',
            message: '',
            hypotheses: null,
            causes: null,
            latency_chart: null,
            errors_chart: null,
            selection: {mode: '', from: this.$route.query.rcaFrom || 0, to: this.$route.query.rcaTo || 0},
        }
    },

    watch: {
        '$route.query'() {
            this.selection.from = this.$route.query.rcaFrom || 0;
            this.selection.to = this.$route.query.rcaTo || 0;
        }
    },

    mounted() {
        this.get();
        this.$events.watch(this, this.get, 'refresh');
    },

    computed: {
        tree() {
            if (!this.hypotheses || !this.hypotheses.length) {
                return [];
            }
            const f = (s, parent) => {
                const h = {
                    id: s.id,
                    name: s.name,
                    children: [],
                    level: parent.level+1,
                    service: s.service,
                    color: palette.hash2(s.service),
                    timeseries: s.timeseries,
                    possible_cause: s.possible_cause,
                    widgets: s.widgets,
                    disable_reason: s.disable_reason,
                    log_pattern: s.log_pattern,
                };
                parent.children.push(h);
                this.hypotheses.filter(s => s.parent_id === h.id).forEach(s => {
                    f(s, h);
                })
            }
            const root = {level: -1, children: []};
            f(this.hypotheses[0], root);
            return root.children;
        },
    },

    methods: {
        explainAnomaly(s) {
            this.selection.from = s.selection.from;
            this.selection.to = s.selection.to;
            this.$router.push({query: {...this.$route.query, rcaFrom: s.selection.from, rcaTo: s.selection.to, ...s.ctx}});
            this.get();
        },
        get() {
            this.loading = true;
            this.$api.getRCA(this.appId, this.selection.from, this.selection.to, (data, meta) => {
                this.loading = false;
                if (meta.error) {
                    this.error = meta.error;
                    return;
                }
                this.hypotheses = data.hypotheses;
                this.causes = data.causes;
                this.latency_chart = data.latency_chart;
                this.errors_chart = data.errors_chart;
            });
        },
    },
};
</script>

<style scoped>
</style>
